// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Loading3QuartersOutlinedSvg from "@ant-design/icons-svg/es/asn/Loading3QuartersOutlined";
import AntdIcon from '../components/AntdIcon';

var Loading3QuartersOutlined = function Loading3QuartersOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: Loading3QuartersOutlinedSvg
  }));
};

Loading3QuartersOutlined.displayName = 'Loading3QuartersOutlined';
export default React.forwardRef(Loading3QuartersOutlined);